<template>
  <div>
    <b-row class="d-flex justify-content-end" align="right">
      <div class="mx-2">
        <b-form-group
          label="Status"
          label-size="sm"
          label-class="font-weight-bold"
        >
          <div
            :class="itemRowBackground(detail.status)"
            size="sm"
            disabled
            class="px-2"
            style="width: fit-content;"
          >
            {{ detail.status }}
          </div>
        </b-form-group>
      </div>
      <div
        v-if="!isEdit && canOpenSummary && detail.bup_summary_id"
        class="summary border-left pl-3 pr-5"
      >
        <a :href="`/bup-summary/${detail.bup_summary_id}/detail`">
          <b>See Summary BUP</b>
        </a>
      </div>
      <div
        v-if="detail.can_generate_bup_coal_loading"
      >
        <b-button
          class="btn-custom btn-generate mr-5"
          variant="info"
          size="sm"
          @click="onClickGenerateCoalLoading"
        >
          Generate BUP Coal Loading
        </b-button>
      </div>
    </b-row>
    <validation-observer ref="form" slim>
    <div>
      <b-row>
        <b-col cols="6">
          <validation-provider
            name="Company"
            rules="required"
            v-slot="{ errors }"
            slim
            class="flex-fill pr-4"
          >
            <b-form-group
              label="Company"
              label-size="sm"
              label-class="font-weight-bold"
              :invalid-feedback="errors[0]"
            >
              <b-form-input
                autocapitalize="off"
                v-model="detail.company_name"
                disabled
                :class="{ 'is-invalid': errors.length }"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="6">
          <validation-provider
            name="Contractor"
            rules="required"
            v-slot="{ errors }"
            slim
            class="flex-fill pr-4"
          >
            <b-form-group
              label="Contractor"
              label-size="sm"
              label-class="font-weight-bold"
              :invalid-feedback="errors[0]"
            >
              <b-form-input
                autocapitalize="off"
                v-model="detail.contractor_name"
                disabled
                :class="{ 'is-invalid': errors.length }"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <validation-provider
            name="Contract Number"
            rules="required"
            v-slot="{ errors }"
            slim
            class="flex-fill mr-4"
          >
            <b-form-group
              label="Contract Number"
              label-size="sm"
              label-class="font-weight-bold"
              :invalid-feedback="errors[0]"
            >
              <b-form-input
                autocapitalize="off"
                v-model="detail.contract_number"
                disabled
                :class="{ 'is-invalid': errors.length }"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="6">
          <validation-provider
            name="Periode"
            rules="required"
            v-slot="{ errors }"
            slim
            class="flex-fill mr-4"
          >
            <b-form-group
              label="Periode"
              label-size="sm"
              label-class="font-weight-bold"
              :invalid-feedback="errors[0]"
            >
              <b-form-input
                autocapitalize="off"
                :value="formatDate(detail.periode)"
                disabled
                :class="{ 'is-invalid': errors.length }"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
    </div>
  </validation-observer>
  </div>
</template>

<script>
import moment from 'moment'
import { hasPermission } from '@/utils/permissions'
import { SUMMARY_VIEW } from '@/fixtures'
import api from '@/api'

export default {
  props: {
    detail: {
      types: Object,
      default: () => ({
        companyName: '',
        contractorName: '',
        contractNumber: '',
        periode: '',
        status: 'Draft'
      })
    },
    isEdit: {
      types: Boolean,
      default: () => false
    },
    options: {
      types: Object,
      default: () => ({
        company: [],
        contractor: []
      })
    }
  },
  data() {
    return {
      canOpenSummary: hasPermission(SUMMARY_VIEW)
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format('MMMM-YYYY')
    },
    itemRowBackground(status) {
      if (status === 'Draft') {
        return 'draft'
      } else if (status === 'Submitted') {
        return 'approved'
      } else if (status === 'Revise') {
        return 'revised'
      } else if (status === 'Waiting Approval') {
        return 'waiting-approval'
      } else {
        return 'waiting-approval'
      }
    },
    async onClickGenerateCoalLoading() {
      try {
        await api.coalAuxiliary.generateCoalLoading(this.$route.params.id)
        this.$nextTick(() => {
          this.$bvToast.toast('Success generate coal loading!', {
            headerClass: 'd-none',
            solid: true,
            variant: 'success'
          })
        })
        this.$emit('fetchDetailCoalAuxiliary')
      } catch ({ response }) {
        this.$nextTick(() => {
          this.$bvToast.toast(`${response.status} - ${response.data.error.message}`, {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
    }
  }
}
</script>

<style scoped>
.status-detail {
  padding: 3px;
}

.summary {
  color: #737AF1;
  font-size: 12px;
  height: 30px;
  text-align: center;
  margin-top: 23px;
}

.btn-generate {
  width: 150px;
  font-weight: bold;
}
</style>
